// Require the Node Slack SDK package (github.com/slackapi/node-slack-sdk)
import axios from 'axios';
import * as Sentry from '@sentry/react';
import {User as RenditionUser} from 'rendition-core/types/Rendition';

function isInternalUser(id: string | undefined) {
    try {
        const internalIds = [
            '1069440166821281534', // kevin figma uid
            '874774465400199228', // rob figma uid
            '364503266366295577', // caleb figma uid
            '831608565533089733', // ben figma uid
            '1131858571128705619', // jeremy figma uid
            '727250377732583802', // bernardo figma uid
            'GnHgBCAREGUAx00mcALeHtuzl9B3', // caleb rendition uid
            'WU3CexdPgJcR8ZzMsD5aQIKoU8S2', // rob rendition uid
            '1oMS5Dyr7WWoMgRqJOmDMtQlbjk1', // kevin rendition uid
            'lB5tiwPX2oZJuymeR2dj92i8Qat1', // ben rendition uid
            'nOcZunJVG4QAe2qIbhq1oVWPqaz2', // jeremy rendition uid
            'urXgU4Wx9ESDN6mEOiYp4KqVuXV2', // bernardo rendition uid
        ];
        return id ? internalIds.includes(id) : false;
    } catch (e) {
        return false;
    }
}

// Post a message to a channel your app is in using ID and message text
export async function sendSlackAlert(
    userId: string,
    user: RenditionUser | undefined,
    text: string,
    channel: 'compile' | 'login' | 'tutorial-flow' | 'gptCodeGen'
) {
    try {
        const channels = {
            login: 'C02M6B7RY1Z',
            compile: 'C02LYLU3TRV',
            profile: 'C036A33AWL8',
            all: 'C035L396KUJ',
            internal: 'C035L35JY75',
            'tutorial-flow': 'C055Q4E08GP',
            gptCodeGen: 'C05A4G9R77T',
        };
        const token = `xoxb-1992733562500-2744063819120-nOsOtQsibKk9owJsYb44wcmM`;

        const channelId = isInternalUser(userId) ? channels.internal : channels[channel];

        const body = `text=${text + '\n' + JSON.stringify(user, null, 2)}&token=${token}&channel=`;

        const res = await axios.post('https://slack.com/api/chat.postMessage', body + channelId, {
            timeout: 10000,
            transformRequest(data, headers) {
                if (headers.common) {
                    delete headers.common['Content-Type'];
                }
                return data;
            },
        });
        if (res.data && res.data.error) {
            console.log('failed to send slack message from client', res.data.error);
            Sentry.captureException('failed to send slack message from client: ' + res.data.error);
        }

        if (!isInternalUser(userId)) {
            // also send to all activity
            await axios.post('https://slack.com/api/chat.postMessage', body + channels.all, {
                timeout: 10000,
                transformRequest(data, headers) {
                    if (headers.common) {
                        delete headers.common['Content-Type'];
                    }
                    return data;
                },
            });
        }
    } catch (error) {
        console.log(error);
        Sentry.captureException(error);
    }
}
